export const Command = '>'

export const Symbol = '@'

export const WorkspaceSymbol = '#'

export const GoToLine = ':'

export const View = 'view '

export const None = ''
